import React from 'react';
import {
  Button,
  FormControl,
  Heading,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  SearchInput,
} from '@alefeducation/ui-elements-library-core';
import { Times } from '@alefeducation/ui-elements-library-icons';
import styled from 'styled-components';
import PermissionCategoryList from './PermissionCategoryList';
import { Organisation } from '../../../../apollo/queries';
import { usePermissionCategoryContext } from '../PermissionCategoryContext';
import {
  ADD_PERMISSIONS,
  EDIT_PERMISSIONS,
  SAVE_CHANGES,
  SEARCH_PERMISSIONS_PLACEHOLDER,
} from '../../../../utils/constants';

const horizontalSpace = () => `
  padding: 0 40px;
`;

const StyledHeaderContainer = styled.div`
  ${horizontalSpace};
  margin-bottom: ${({ theme: { space } }: any) => `${space[14]}px`};
`;

const StyledFormControlContainer = styled.div`
  ${horizontalSpace};
  margin-bottom: 22px;
`;

const Separator = styled.div`
  background-color: #ecedef;
  height: 1px;
  margin-bottom: 16px;
`;

const StyledModalContent = styled.div`
  > div:first-child {
    padding: 0 !important;
    margin-bottom: 24px;
  }
`;

interface Props {
  open: boolean;
  organisation?: Organisation;
  isEdit?: boolean;
  setShowModal: (val: boolean) => void;
}

const StyledModal = styled(Modal)`
  .MuiPaper-root {
    max-height: 90vh;
  }
`;

const AddPermissionsModal: React.FC<Props> = ({ open, setShowModal }) => {
  const {
    onAddPermissions,
    onSearch,
    searchedText,
    onPermissionDialogToggle,
    isEdit,
  } = usePermissionCategoryContext();
  const headerTitle = isEdit ? EDIT_PERMISSIONS : ADD_PERMISSIONS;
  const submitButtonText = isEdit ? SAVE_CHANGES : ADD_PERMISSIONS;

  const closeModal = () => {
    onPermissionDialogToggle(false);
    setShowModal(false);
  };

  return (
    <StyledModal open={open} data-testid="add-permissions-modal" size="medium">
      <ModalHeader>
        <Times
          role="icon"
          aria-label="cross"
          color="primary.40"
          height="14"
          width="14"
          cursor="pointer"
          onClick={closeModal}
        />
      </ModalHeader>
      <StyledModalContent>
        <ModalContent>
          <StyledHeaderContainer>
            <Heading variant="heading-medium" weight="bold" color="text.100">
              {headerTitle}
            </Heading>
          </StyledHeaderContainer>
          <StyledFormControlContainer>
            <FormControl>
              <SearchInput
                onSearch={() => {}}
                onChange={(e) => {
                  onSearch(e.target.value);
                }}
                onClear={() => onSearch('')}
                value={searchedText}
                placeholder={SEARCH_PERMISSIONS_PLACEHOLDER}
              />
            </FormControl>
          </StyledFormControlContainer>
          <Separator />
          <PermissionCategoryList />
        </ModalContent>
      </StyledModalContent>
      <ModalActions>
        <Button
          variant="secondary"
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            onAddPermissions();
            closeModal();
          }}
        >
          {submitButtonText}
        </Button>
      </ModalActions>
    </StyledModal>
  );
};

export default AddPermissionsModal;
